<template>
  <div
    class="main main-really-raised w-50- ml-auto mr-auto"
    :class="'view-' + view"
  >
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card- card-signup- no-shadow">
            <div class="card-body px-3">
              <div class="row">
                <div
                  class="mb-3"
                  :class="view == 'compact' ? 'col-md-3' : 'col-12'"
                >
                  <router-link
                    :to="{
                      name: 'overall-service-cn',
                      params: {
                        services: ['886'],
                        prices: services,
                        currency: currency,
                      },
                    }"
                    @click="show_menu = false"
                    class="flex-wrap-on-small border border-primary rounded p-4 d-flex"
                    :class="view == 'compact' ? 'flex-wrap' : ''"
                  >
                    <!-- <label class="checkbox-holder"  @click.stop="">
											<input type="checkbox" @click.stop="" v-model="selected_services" value="886">
										</label> -->
                    <div class="service-icon-holder">
                      <i class="fas fa-chart-area"></i>
                      <span class="api-id">API: 886</span>
                      <span class="api-price"
                        >{{ services[886] }} {{ currency }}</span
                      >
                    </div>
                    <div
                      v-if="view == 'compact'"
                      class="service-title text-center w-100"
                    >
                      {{ $t("message.find_partner.fuzzy_search_cn") }}
                    </div>
                    <div class="service-text-holder" v-if="view != 'compact'">
                      <div class="service-title">
                        {{ $t("message.find_partner.fuzzy_search_cn") }}
                      </div>
                      <div class="service-description">
                        {{
                          $t("message.find_partner.fuzzy_search_description")
                        }}
                      </div>
                    </div>
                  </router-link>
                </div>
                <div
                  class="mb-3"
                  :class="view == 'compact' ? 'col-md-3' : 'col-12'"
                >
                  <router-link
                    :to="{
                      name: 'overall-service-cn',
                      params: {
                        services: ['430', '930', '701', '213', '736'],
                        prices: services,
                        currency: currency,
                      },
                    }"
                    @click="show_menu = false"
                    class="flex-wrap-on-small border border-primary rounded p-4 d-flex"
                    :class="view == 'compact' ? 'flex-wrap' : ''"
                  >
                    <!-- <label class="checkbox-holder"  @click.stop="">
											<input type="checkbox" @click.stop="" v-model="selected_services" value="886">
										</label> -->
                    <div class="service-icon-holder">
                      <i class="fas fa-briefcase"></i>
                      <!-- <span class="api-id">API: 886</span> -->
                      <!-- <span class="api-price">{{services[886]}} {{currency}}</span> -->
                    </div>
                    <div
                      v-if="view == 'compact'"
                      class="service-title text-center w-100"
                    >
                      {{ $t("message.find_partner.group_search") }}
                    </div>
                    <div class="service-text-holder" v-if="view != 'compact'">
                      <div class="service-title">
                        {{ $t("message.find_partner.group_search") }}
                      </div>
                      <div class="service-description">
                        {{
                          $t("message.find_partner.group_search_description")
                        }}
                      </div>
                    </div>
                  </router-link>
                </div>
                <!-- <div class="mb-3" :class="view=='compact'?'col-md-3':'col-12'">
									
									<router-link :to="{name: 'overall-service-cn',params: {services: ['430'], prices: services, currency: currency}}"
										@click="show_menu = false" class="border flex-wrap-on-small border-primary rounded p-4 d-flex" :class="view=='compact'?'flex-wrap':''">
										<label class="checkbox-holder"  @click.stop="">
											<input type="checkbox" @click.stop="" v-model="selected_services" value="430">
										</label>
										<div class="service-icon-holder">
											<i class="fas fa-briefcase"></i>
											<span class="api-id">API: 430</span>
											<span class="api-price">{{services[430]}} {{currency}}</span>
										</div>
										<div v-if="view=='compact'" class="service-title text-center w-100">{{$t('message.find_partner.common_info_cn')}}</div>
										<div class="service-text-holder" v-if="view!='compact'">
											<div class="service-title">{{$t('message.find_partner.common_info_cn')}}</div>
											<div class="service-description">{{$t('message.find_partner.common_info_cn_description')}}</div>
										</div>
									</router-link>
											
								</div> -->
                <!-- <div class="mb-3" :class="view=='compact'?'col-md-3':'col-12'">
									
									<router-link :to="{name: 'overall-service-cn',params: {services: ['930'], prices: services, currency: currency}}"

										@click="show_menu = false" class="border flex-wrap-on-small border-primary rounded p-4 d-flex" :class="view=='compact'?'flex-wrap':''">
										<label class="checkbox-holder"  @click.stop="">
											<input type="checkbox" @click.stop="" v-model="selected_services" value="930">
										</label>
										<div class="service-icon-holder">
											<i class="fas fa-gavel"></i>
											<span class="api-id">API: 930</span>
											<span class="api-price">{{services[930]}} {{currency}}</span>
										</div>
										<div v-if="view=='compact'" class="service-title text-center w-100">{{$t('message.find_partner.court_notice_info')}}</div>
										<div class="service-text-holder" v-if="view!='compact'">
											<div class="service-title">{{$t('message.find_partner.court_notice_info')}}</div>
											<div class="service-description">{{$t('message.find_partner.court_notice_info_description')}}</div>
										</div>
									</router-link>
											
								</div> -->
                <!-- <div class="mb-3" :class="view=='compact'?'col-md-3':'col-12'">
									
									<router-link :to="{name: 'overall-service-cn',params: {services: ['701'], prices: services, currency: currency}}"

										@click="show_menu = false" class="border flex-wrap-on-small border-primary rounded p-4 d-flex" :class="view=='compact'?'flex-wrap':''">
										<label class="checkbox-holder"  @click.stop="">
											<input type="checkbox" @click.stop="" v-model="selected_services" value="701">
										</label>
										<div class="service-icon-holder">
											<i class="fas fa-newspaper"></i>
											<span class="api-id">API: 701</span>
											<span class="api-price">{{services[701]}} {{currency}}</span>
										</div>
										<div v-if="view=='compact'" class="service-title text-center w-100">{{$t('message.find_partner.corporate_news_search')}}</div>
										<div class="service-text-holder" v-if="view!='compact'">
											<div class="service-title">{{$t('message.find_partner.corporate_news_search')}}</div>
											<div class="service-description">{{$t('message.find_partner.corporate_news_search_description')}}</div>
										</div>
									</router-link>
								</div> -->
                <!-- <div class="mb-3" :class="view=='compact'?'col-md-3':'col-12'">
									
									<router-link :to="{name: 'overall-service-cn',params: {services: ['213'], prices: services, currency: currency}}"

										@click="show_menu = false" class="border flex-wrap-on-small border-primary rounded p-4 d-flex" :class="view=='compact'?'flex-wrap':''">
										<label class="checkbox-holder"  @click.stop="">
											<input type="checkbox" @click.stop="" v-model="selected_services" value="213">
										</label>
										<div class="service-icon-holder">
											<i class="fas fa-file-invoice"></i>
											<span class="api-id">API: 213</span>
											<span class="api-price">{{services[213]}} {{currency}}</span>
										</div>
										<div v-if="view=='compact'" class="service-title text-center w-100">{{$t('message.contragent_search.annual_report')}}</div>
										<div class="service-text-holder" v-if="view!='compact'">
											<div class="service-title">{{$t('message.contragent_search.annual_report')}}</div>
											<div class="service-description">{{$t('message.contragent_search.annual_report_description')}}</div>
										</div>
									</router-link>
											
								</div> -->
                <!-- <div class="mb-3" :class="view=='compact'?'col-md-3':'col-12'">
									
									<router-link :to="{name: 'overall-service-cn',params: {services: ['736'], prices: services, currency: currency}}"

										@click="show_menu = false" class="border flex-wrap-on-small border-primary rounded p-4 d-flex" :class="view=='compact'?'flex-wrap':''">
										<label class="checkbox-holder"  @click.stop="">
											<input type="checkbox" @click.stop="" v-model="selected_services" value="736">
										</label>
										<div class="service-icon-holder">
											<i class="fas fa-chart-area"></i>
											<span class="api-id">API: 736</span>
											<span class="api-price">{{services[736]}} {{currency}}</span>
										</div>
										<div v-if="view=='compact'" class="service-title text-center w-100">{{$t('message.contragent_search.enterprise_risk_scan')}}</div>
										<div class="service-text-holder" v-if="view!='compact'">
											<div class="service-title">{{$t('message.contragent_search.enterprise_risk_scan')}}</div>
											<div class="service-description">{{$t('message.contragent_search.enterprise_risk_scan_description')}}</div>
										</div>
									</router-link>
											
								</div> -->
              </div>
              <button
                class="btn btn-success"
                v-if="selected_services.length > 0"
                @click="openBulkServices"
              >
                {{ $t("message.contragent_search.do_bulk") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import moment from "moment";
export default {
  props: ["view"],
  data() {
    return {
      current_tab: 0,
      selected_services: [],
      services: {
        430: "", //companyinfo
        930: "", //court
        701: "", //news
        213: "", //annual report
        736: "", //risk
        886: "", //enterprice fuzzy
      },
      currency: "",
    };
  },
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.loadPrices();
  },
  computed: {},
  methods: {
    loadPrices() {
      var keys = Object.keys(this.services);
      axios
        .get(window.base + "/admin/GetAllBillingServiceInfo")
        .then((response) => {
          keys.forEach((key) => {
            if (typeof response.data == "object") {
              var r = response.data.find(
                (element) => element.billing_service_code === key,
              );
              this.services[key] = r.billing_service_price;
              this.currency = r.billing_service_cur;
            }
          });
        });
    },
    openBulkServices() {
      this.$router.push({
        name: "overall-service-cn",
        params: {
          services: this.selected_services,
          prices: this.services,
          currency: this.currency,
        },
      });
    },
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
  },
};
</script>
<style>
.service-icon-holder {
  min-width: 100px;
  min-height: 100px;
  max-height: 100px;
  max-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  background: rgba(0, 123, 255, 0.3);
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
}
.service-icon-holder span.api-id {
  font-size: 10px;
  display: block;
  position: absolute;
  bottom: 5px;
  left: 5px;
  right: 5px;
  text-align: center;
}
.service-text-holder {
  flex-basis: 100%;
}
.service-text-holder .service-title {
  font-weight: bold;
}
.service-text-holder .service-description {
  font-size: 13px;
}
.checkbox-holder {
  width: 30px;
  height: 100px;
  display: flex;
  justify-content: center;
}
.api-price {
  font-size: 10px;
  display: block;
  position: absolute;
  bottom: -20px;
  left: 5px;
  right: 5px;
  text-align: center;
}
.view-compact .service-icon-holder {
  min-width: calc(100% - 40px);
  max-width: calc(100% - 40px);
}

@media screen and (max-width: 768px) {
  .flex-wrap-on-small {
    flex-wrap: wrap;
  }
}
</style>
